import styled from "styled-components";

interface StyledDatePickerProps {
  $marginRight?: string;
}

export const StyledDatePickerContainer = styled.div<StyledDatePickerProps>`
  width: 100%;
  border-radius:6px;
    margin-bottom:0;

  display: flex;
  align-items: center;;

  .MuiInputLabel-root {
    color: rgba(0, 0, 0, 0.6);
    
    &.Mui-focused {
      color: #e39435;
    }
    
    &.Mui-error {
      color: #f44336;
    }
  }

  .MuiFormHelperText-root {
    color: #f44336;
    margin: 4px 0 0 0;
  }
`;

export const StyledDatePickerContainerSignup = styled.div<StyledDatePickerProps>`
  width: 100%;
  margin-bottom:1rem;

  .MuiInputLabel-root {
    color: rgba(0, 0, 0, 0.6);
    
    &.Mui-focused {
      color: #e39435;
    }
    
    &.Mui-error {
      color: #f44336;
    }
  }

  .MuiFormHelperText-root {
    color: #f44336;
    margin: 4px 0 0 0;
  }
`;
